import { LocaleEnum } from "@/services/internalApiV1";

// The assistants' and mini tools' language filter as the URL and the search
// forms carry it: comma-separated locales ("de,nl"); "" is every language.
// docs/exec-plans/ai-content-locale.md (D1).

export function parseLocalesFilter(value?: string): LocaleEnum[] {
  // Read inside the call: this module is auto-imported, and tests that mock
  // the API module without LocaleEnum must still be able to load it.
  const knownLocales: string[] = Object.values(LocaleEnum);
  return (value ?? "")
    .split(",")
    .filter((locale): locale is LocaleEnum => knownLocales.includes(locale));
}

export function formatLocalesFilter(locales: readonly string[]): string {
  return parseLocalesFilter(locales.join(",")).join(",");
}

// The `locales[]` API parameter; undefined (left out) means every language.
export function localesParam(value?: string): LocaleEnum[] | undefined {
  const locales = parseLocalesFilter(value);
  return locales.length > 0 ? locales : undefined;
}
